import { ERROR_CODE, isNormalizedResponse } from '@common/utils';
import { redirect } from 'next/navigation';

import { UNAUTH_API } from '@/api';
import { ROUTES } from '@/constants';

interface UseGetHometownNewsRelatedListProps {
  idIdx: string;
}

export const useGetHometownNewsRelatedList = async ({
  idIdx,
}: UseGetHometownNewsRelatedListProps) => {
  try {
    const { context } = await UNAUTH_API.getRelatedHometownNewsList({
      hometownNewsIdIdx: idIdx,
    });
    if (!context) throw Error('hometown news list context not valid');

    return {
      list: context.contents ?? [],
      keyword: context.search_keyword ?? '관련 소식',
    };
  } catch (e) {
    if (isNormalizedResponse(e)) {
      const { return_code } = e;

      if (return_code === ERROR_CODE.HIDDEN) {
        return redirect(ROUTES.ERROR.pathname({ code: return_code }));
      }
    }

    throw e;
  }
};
